import { render, staticRenderFns } from "./AwardsHome.vue?vue&type=template&id=871099b6&scoped=true"
import script from "./AwardsHome.vue?vue&type=script&lang=js"
export * from "./AwardsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871099b6",
  null
  
)

export default component.exports